<template>
  <div>
    <div class="accountMain">
      <el-tabs type="border-card" v-model="activeName" @tab-click="changetab">
        <el-tab-pane label="订单流水" name="assembly"> </el-tab-pane>
        <el-tab-pane label="收支统计" name="assemblyStorage"> </el-tab-pane>
        <el-tab-pane label="教练统计" name="coachStatistics">
          <el-form :inline="true" :model="accountFrom">
            <el-form-item>
              <el-date-picker
                v-model="accountFrom.dateStart"
                type="date"
                placeholder="选择开始日期"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                @change="dateChange"
              >
              </el-date-picker>
              至
              <el-date-picker
                v-model="accountFrom.dateEnd"
                type="date"
                placeholder="选择结束日期"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                @change="dateChange"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-select
                filterable
                clearable
                v-model="accountFrom.shopId"
                size="small"
                placeholder="门店筛选"
                :disabled="showshopId"
                @change="shopIdChange"
              >
                <el-option
                  v-for="item in this.mdSelectList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                clearable
                v-model="accountFrom.queryData"
                placeholder="教练姓名"
                size="small"
                @input="queryDataChange"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item>
              <el-button type="primary" @click="accountSearch" size="small">
                搜索
              </el-button>
              <el-button
                type="primary"
                @click="accountSearchClear"
                size="small"
              >
                清空
              </el-button>
            </el-form-item> -->
          </el-form>
          <div class="positionR">
            <el-button
              type="primary"
              class="positionA"
              size="mini"
              @click="copyOut"
            >
              导出
            </el-button>
          </div>
          <el-table :data="dataList" v-loading="loading">
            <el-table-column
              v-for="item in titleList"
              :key="item.value"
              :prop="item.value"
              :label="item.text"
              align="center"
            >
            </el-table-column>
          </el-table>
          <!-- <el-pagination
            class="pageClass"
            @current-change="otCurrentChange"
            layout="total,prev, pager,next,jumper"
            :current-page.sync="otResult.current"
            :page-size="otResult.size"
            :total="otResult.total"
          >
          </el-pagination> -->
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import {
  getCoachStatic,
  getCoachForExcel,
} from "@/api/standingBookManagement.js";
import { dateNowYear } from "../../utils/util";
import { getAntDeptSelect } from "../../api/BusinessManagement";
export default {
  data() {
    return {
      activeName: "coachStatistics",
      mdSelectList: [],
      accountFrom: {
        dateStart: dateNowYear(),
        dateEnd: dateNowYear(),
        shopId: "",
        queryData: "",
        // pageNo: 1,
        // pageSize: 10,
      },
      // otResult:{},
      titleList: [],
      dataList: [],
      showshopId: false,
      loading: false
    };
  },
  created() {
    this.accountFrom.shopId = this.$route.query.shopId;
  },
  mounted() {
    this.getCoachStatic(this.accountFrom);
    this.getAntDeptSelect();
    this.isStoreManager();
    // console.log(dateNowYear());
  },
  methods: {
    changetab(tab) {
      if (tab.label == "订单流水") {
        this.$router.push({
          path: "/AccountManagement/assembly",
          query: { shopId: this.accountFrom.shopId },
        });
        // let routeData = this.$router.resolve({
        //   path: "/AccountManagement/assembly",
        // });
        // window.open(routeData.href, "_blank");
      } else if (tab.label == "收支统计") {
        this.$router.push({
          path: "/AccountManagement/assemblyStorage",
          query: { shopId: this.accountFrom.shopId },
        });
      }
    },
    //获取门店下拉菜单
    getAntDeptSelect() {
      getAntDeptSelect().then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "暂无门店数据",
            });
          } else {
            this.mdSelectList = res.data.result;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 搜索
    // accountSearch() {
    //   if (
    //     this.accountFrom.dateStart&&
    //     this.accountFrom.dateEnd &&
    //     new Date(this.accountFrom.dateStart).getTime() >
    //       new Date(this.accountFrom.dateEnd).getTime()
    //   ) {
    //     this.$message.error("开始时间不能大于结束时间");
    //     return;
    //   }
    //   this.getCoachStatic(this.accountFrom);
    // },
    // 清空
    // accountSearchClear() {
    //   this.accountFrom = {
    //     dateStart: "",
    //     dateEnd: "",
    //     shopId: "",
    //     queryData: "",
    //     // pageNo: 1,
    //     // pageSize: 10,
    //   };
    //   this.getCoachStatic(this.accountFrom);
    // },
    // 教练列表
    getCoachStatic(params) {
      this.loading = true;
      getCoachStatic(params).then((res) => {
        this.loading = false;
        if (res.status === 200 && res.data.success) {
          if (res.data.result.dataList.length === 0) {
            this.$Notice.open({
              title: "暂无查询到的教练统计数据",
            });
            this.dataList = [];
          } else {
            this.titleList = res.data.result.titleList;
            this.dataList = res.data.result.dataList;
            // this.otResult = res.data.result;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //  otCurrentChange(newPage) {
    //   this.$set(this.accountFrom, "pageNo", newPage);
    //   this.getFlowTypeStatistics(this.accountFrom);
    // },
    dateChange() {
      // console.log(this.accountFrom.dateStart);
      // console.log(new Date(this.accountFrom.dateStart));
      // console.log(new Date(this.accountFrom.dateStart).getTime());
      // console.log(this.accountFrom.dateEnd);
      // console.log(new Date(this.accountFrom.dateEnd));
      // console.log(new Date(this.accountFrom.dateEnd).getTime());
      // if (
      //   this.accountFrom.dateStart &&
      //   this.accountFrom.dateEnd &&
      //   new Date(this.accountFrom.dateStart).getTime() >
      //     new Date(this.accountFrom.dateEnd).getTime()
      // ) {
      //   this.$message.error("开始时间不能大于结束时间");
      //   return;
      // }
      // this.accountFrom.pageNo = 1;
      this.getCoachStatic(this.accountFrom);
    },
    shopIdChange() {
      // this.accountFrom.pageNo = 1;
      this.getCoachStatic(this.accountFrom);
    },
    queryDataChange() {
      // this.accountFrom.pageNo = 1;
      this.getCoachStatic(this.accountFrom);
    },
    // 导出
    copyOut() {
      getCoachForExcel(this.accountFrom).then((res) => {
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        downloadElement.download = "教练统计";
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);
      });
    },
    //如果是店长账号 只能看见自己门店的台账
    isStoreManager() {
      if (sessionStorage.roleCode === "storeManager") {
        this.accountFrom.shopId = sessionStorage.shopId;
        this.showshopId = true;
      }
    },
  },
};
</script>

<style scoped>
.accountMain {
  padding: 30px;
}
.positionR {
  position: relative;
  height: 40px;
}
.positionA {
  position: absolute;
  top: 0;
  right: 30px;
}
.pageClass {
  margin: 30px 10px;
}
</style>
